export const optionsUserType = [
  //   {
  //     label: "What best describes you?",
  //     value: "1",
  //   },
  {
    label: "Individual Pro",
    value: "individual",
  },
  {
    label: "Bussiness Pro",
    value: "bussiness",
  },
];

export const optionsUserCategory = [
  {
    label: "Contractor",
    value: "contractor",
  },
  {
    label: "Plumber",
    value: "plumber",
  },
  {
    label: "HVAC",
    value: "HVAC",
  },
  {
    label: "Tiler",
    value: "tiler",
  },
  {
    label: "Pool Maintenance",
    value: "poolMaintenance",
  },
  {
    label: "Window Installer",
    value: "windowInstaller",
  },
  {
    label: "Landscaping/gardening",
    value: "landscaping/gardening",
  },
  {
    label: "Roofer",
    value: "roofer",
  },
  {
    label: "Electrical Company",
    value: "electrical Company",
  },
  {
    label: "Painter",
    value: "painter",
  },
];

// export { optionsUserCategory, optionsUserType };
